<template>
	<div class="decade-wrap" v-bind:class="feed">
		<div class="loading message-to-visitor tbs" v-if="loading">
			Loading
		</div>

		<div v-if="error" class="error message-to-visitor">
			{{ error }}
		</div>

		<div v-if="decadeData" class="content">
			<timeline-row
				v-for="(item, index) in decadeData"
				v-bind:rowdata="item"
				v-bind:key="index"
				v-bind:lPos="lPos"
				v-bind:rootPath="rootPath"
				v-bind:apiPath="apiPath"
				v-bind:rowdecades="rowdecades"
			></timeline-row>
		</div>
	</div>
</template>

<script>
// import '../assets/datafile.js';
// console.log(arr);
import TimelineRow from "./TimelineRow.vue";
// require("intersection-observer");
export default {
	components: {
		TimelineRow
	},
	props: ['rootPath','apiPath','feed','lPos','activeDecade'],
	data() {
		return {
			publicPath: process.env.BASE_URL,
			loading: false,
			decadeData: null,
			error: null,
			initopen: null,
			wpTarget: null,
			rowdecades:[]
		};
	},
	created() {
		// fetch the data when the view is created and the data is
		// already being observed
		this.fetchData();
		// let createThis = this;

		// this.decades = document.querySelectorAll(".decade-sep");
		// var configDecade = {
		// 	threshold: 0.6
		// };
		// var currDecade = null;
		// this.decadeObserver = new IntersectionObserver(function(entries) {
		// 	// function (entries, self) {
		// 	entries.forEach(function(entry) {
		// 		if (entry.isIntersecting) {
		// 			// var targetURL = entry.target.dataset.url;
		// 			var targetURL = entry.target.dataset.decade;

		// 			if (createThis.targetURL !== currDecade) {
		// 				createThis.$parent.setNewURL(targetURL);
		// 			} // if(currDecade !== en)
		// 		}
		// 	});
		// }, configDecade); // decades.forEach(decade => { decadeObserver.observe(decade); });
	},
	computed: {
		// dataPath(){
		// 	return require('../assets/datafile.js')
		// }
	},
	watch: {
		// call again the method if the route changes
		$route: "fetchData",
		feed: "fetchData"
	},
	methods: {
		fetchData() {
			this.error = this.decadeData = null;
			this.loading = true;
			this.$parent.lPos = -1;
			this.$parent.activeDecade = null;
			this.rowdecades = [];
			let localThis = this;
			let baseURI = this.apiPath + "/?get=datagen&pub=approved&preview=1";
			let filenameActual = '_pd.js';
			if(localThis.feed === 'ps1'){
				filenameActual = '_pd-ps1.js';
				baseURI = this.apiPath + "/?get=datagen-ps1&pub=approved&preview=1";
			} else if(localThis.feed === 'moma'){
				filenameActual = '_pd-moma.js';
				baseURI = this.apiPath + "/?get=datagen-moma&pub=approved&preview=1";
			}
			// flag fetch
			// Uncomment next line for local assets
			baseURI = this.rootPath + 'static/uploads/data/'+filenameActual+'?v=1.05';
			this.$http
				.get(baseURI)
				.then(result => {
					// this.users = result.data
					// eslint-disable-next-line
					// console.log(result.data);
					localThis.decadeData = result.data;
					localThis.loading = false;
					localThis.init();
				})
				.catch(function(err) {
					localThis.error = err.toString();
					localThis.loading = false;
				});
		},
		init() {
			let initThis = this;
			var initialURL = window.location.pathname;
			// let feedLoad = 'main';
			if(initialURL.includes("/moma-ps1/")){
				this.$parent.feed = 'ps1';
				initialURL = initialURL.replace("/moma-ps1/","");
			} else if(initialURL.includes("/moma/")){
				this.$parent.feed = 'moma';
				initialURL = initialURL.replace("/moma/","");
			}
			var initialDecade = initialURL
				.replace("/interactives/moma_through_time/", "")
				.replace("/", "")
				.replace("/", "")
				.replace("/", "")
				.replace("/", "");

			setTimeout(function() {
				initThis.$parent.needsResize = true;
			},500);
			setTimeout(function() {
				initThis.$parent.needsResize = true;
			},1000);
			if (initialDecade !== "") {
				let initialScrollPos = 0;
				if (initialDecade.length > 4) {
					initThis.wpTarget = initialDecade.substring(4);
				}

				setTimeout(function() {
					if (initThis.wpTarget !== null) {
						initialScrollPos =
							document.querySelector(
								".article-" + initThis.wpTarget
							).offsetTop + -100;
					} else {
						initialScrollPos =
							document.querySelector(
								'[data-decade="' + initialDecade + '"]'
							).offsetTop - 100;
					}
					if (initialScrollPos > 0) {
						document.documentElement.scroll(0, initialScrollPos);
						document.documentElement.pageYOffset = initialScrollPos;
					}

					window.cb();
				}, 500);
				// var initialScrollPos = document.querySelector('[data-url="' + initialDecade + '"]').offsetTop;
			} // Initialize Decade scroll

			// this.decades.forEach(function(decade) {
			// 	initThis.decadeObserver.observe(decade);
			// });
		}		
	}
};
</script>

<style lang="scss">
@import "../sass/_mq.scss";
section {
	padding:0 24px;
	margin-bottom:24px;
	&.intro { margin-bottom:0; }
	&.up {
		display:flex;
		flex-direction:row;
		flex-wrap:wrap;
		align-items: flex-start;
	}
	@include tabletBelow {
		padding:0;
		// margin-bottom:30px;
		section {
			padding:0;
		}
	}
}
.decade-wrap {
	padding-top:80px;
	.content {
		margin-bottom:70vh;
	}
	// animation: fadein 1s forwards;
	// &.ps1 {
	// 	animation: fadeinAlt1 1s forwards;
	// }
	// &.moma {
	// 	animation: fadeinAlt2 1s forwards;
	// }
}
.message-to-visitor {
	text-align: center;
	padding: 80px 80px 200px;
	&.loading {
		min-height:90vh;
		display: flex;
		align-items:center;
		justify-content:center;
	}

}
#imgEnlargeModal {
	position:fixed;
	top:0;
	left:0;
	width:100%;
	height:100%;
	backface-visibility:hidden;
	z-index:10;
	@include tabletBelow {
		&:BEFORE {
			content:"";
			background:black;
			position:absolute;
			top:17px;
			right:18px;
			width:50px;
			height:50px;
			border-radius:50%;
			z-index:3;
		}
	}
	.modal-close {
		@include tabletBelow {
			right:12px;
			top:12px;
			z-index:4;
		}
	}
}
.modal-close {
	z-index:2;
}
.modalbg {
	position:absolute;
	top:0;
	left:0;
	right:0;
	bottom:0;
	background:black;
	background:rgba(0,0,0,0.88);
}
.modal-scrollable {
	position:absolute;
	top:0;
	left:0;
	right:0;
	bottom:0;
	overflow:auto;
	display: flex;
	align-items: center;
	padding:20px;
	-webkit-overflow-scrolling: touch;
	overscroll-behavior: none;
	.clickbg {
		position:absolute;
		top:0;
		left:0;
		bottom: 0;
		right:0;
	}
	img {
		display:block;
		margin:auto;
		max-width:90%;
		position:relative;
		z-index:2;
		@include tabletBelow {
			max-width:300%;
		}
	}
}
@keyframes fadeinAlt1 {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
@keyframes fadeinAlt2 {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
</style>
